import { render } from "./SocialNetwork.vue?vue&type=template&id=73a0cc66&scoped=true"
import script from "./SocialNetwork.vue?vue&type=script&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&lang=js"

import "./SocialNetwork.vue?vue&type=style&index=0&id=73a0cc66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a0cc66"]])

export default __exports__